"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _react = _interopRequireDefault(require("react"));

var _MenuItemContent = _interopRequireDefault(require("./MenuItemContent"));

var _ExpandableSection = _interopRequireDefault(require("../ExpandableSection"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _MenuLeaf = _interopRequireDefault(require("./MenuLeaf"));

var styles = function styles(theme) {
  return {
    expander: {
      borderBottom: 'none'
    },
    expanderMargins: {
      padding: 0
    },
    expanderSummary: {
      textTransform: 'uppercase',
      '&:first-child': {
        padding: "10px ".concat(theme.spacing(2), "px"),
        borderBottom: "1px solid ".concat(theme.palette.divider)
      }
    },
    expanderSummaryExpanded: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    expanderIconExpanded: {
      color: theme.palette.secondary.contrastText
    },
    expanderDetails: {
      '$expander &': {
        paddingBottom: 0
      }
    },
    expanderContent: {
      textTransform: 'none'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles, {
  name: 'RSFMenuBranch'
});

var MenuBranch = /*#__PURE__*/_react["default"].memo(function (props) {
  props = Object.assign({}, {
  ExpanderComponent: _ExpandableSection["default"]
}, props);
  var depth = props.depth,
      item = props.item,
      ExpanderComponent = props.ExpanderComponent,
      itemProps = props.itemProps;
  var isLeaf = !item.items.some(function (child) {
    return child.items && child.items.length > 0;
  });
  var classes = useStyles();

  if (item.expanded != null && item.items && item.items.length && isLeaf) {
    return /*#__PURE__*/_react["default"].createElement(ExpanderComponent, {
      title: item.text,
      defaultExpanded: item.expanded,
      classes: {
        root: classes.expander,
        margins: classes.expanderMargins,
        summary: classes.expanderSummary,
        summaryExpanded: classes.expanderSummaryExpanded,
        expandIconExpanded: classes.expanderIconExpanded,
        details: classes.expanderDetails
      }
    }, item.items.map(function (child, i) {
      return /*#__PURE__*/_react["default"].createElement(_MenuLeaf["default"], {
        key: i,
        item: child,
        depth: depth,
        classes: {
          listItem: classes.expanderContent
        }
      });
    }));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_MenuItemContent["default"], {
      item: item,
      depth: depth,
      leaf: false,
      listItemProps: itemProps
    });
  }
});

var _default = MenuBranch;
exports["default"] = _default;
MenuBranch.propTypes = {
  /**
   * Overrides the default component for expandable items
   */
  ExpanderComponent: _propTypes["default"].elementType.isRequired,

  /**
   * Additional props for the underlying ListItem
   */
  itemProps: _propTypes["default"].object
};
